import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { TrustBadges } from '../ui/TrustBadges';
export function CTAFinal() {
  return <section id="cta-final" className="py-[120px] bg-[radial-gradient(ellipse_80%_60%_at_50%_50%,rgba(224,122,80,0.18)_0%,transparent_70%),linear-gradient(180deg,#1a0f08_0%,#120806_100%)] text-center relative overflow-hidden" data-id="element-160">
      <div className="absolute inset-0 z-0" data-id="element-161">
        <img src="https://images.unsplash.com/photo-1493894473891-10fc1e5dbd22?w=800&q=60" alt="" className="w-full h-full object-cover opacity-[0.03]" loading="lazy" data-id="element-162" />
      </div>
      <div className="container-custom relative z-10" data-id="element-163">
        <div className="flex flex-col items-center" data-id="element-164">
          <motion.p initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[11px] tracking-[3px] uppercase text-gold mb-3" data-id="element-165">
            Último llamado
          </motion.p>
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="w-[60px] h-[2px] bg-gradient-to-r from-gold to-gold-light mx-auto mb-6" data-id="element-166" />

          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          duration: 0.7,
          type: 'spring',
          bounce: 0.3
        }} className="font-display text-[clamp(28px,4vw,48px)] font-black leading-[1.2] max-w-[680px] mx-auto mb-5 text-white" data-id="element-167">
            Deja de adivinar qué te hace daño.
            <br data-id="element-168" />
            <span className="text-gold" data-id="element-169">Empezá el Protocolo hoy.</span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          duration: 0.6
        }} className="text-[17px] text-gray mb-10 max-w-[520px] mx-auto leading-[1.6]" data-id="element-170">
            Más de 1.200 personas ya recuperaron el control de su digestión. En
            72 horas podés sentir la diferencia. El único riesgo es no
            intentarlo.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          y: 0,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.7,
          type: 'spring',
          bounce: 0.4
        }} className="flex flex-col items-center gap-5 w-full max-w-[320px] mx-auto" data-id="element-171">
            <Button href="#oferta" variant="primary" fullWidth data-id="element-172">
              ACCEDER AL PROTOCOLO →
            </Button>
            <TrustBadges data-id="element-173" />
          </motion.div>
        </div>
      </div>
    </section>;
}